import { Button } from '@interstate/components/Button';
import { DocumentDuplicateIcon, LinkIcon } from '@interstate/components/Icons';
import { TextInput } from '@interstate/components/TextInput';
import { COPY_URL_BUTTON_TEXT } from '../constants';
import { SendToCustomerDialogFooter } from './SendToCustomerDialogFooter.style';

export interface ISendToCustomerDialogFooterProps {
    prefix: string;
    shareUrl: string;
    handleShareUrlChange(): void;
    handleCopyClick(): void;
}

const SendToCustomerDialogFooterInterstate = ({
    prefix,
    shareUrl,
    handleShareUrlChange,
    handleCopyClick
}: ISendToCustomerDialogFooterProps) => {
    return (
        <>
            <SendToCustomerDialogFooter data-testid="send-to-customer-dialog-footer">
                <TextInput
                    label="Copy URL"
                    name={`${prefix}-share-url-input`}
                    onChange={handleShareUrlChange}
                    data-testid={`${prefix}-share-url-input`}
                    value={shareUrl}
                    disabled
                    inputPrefix={<LinkIcon />}
                />
                <Button
                    data-testid={`${prefix}-copy-url-button`}
                    size="default"
                    onClick={handleCopyClick}
                    startIcon={<DocumentDuplicateIcon />}
                    type="submit"
                >
                    {COPY_URL_BUTTON_TEXT}
                </Button>
            </SendToCustomerDialogFooter>
        </>
    );
};

export default SendToCustomerDialogFooterInterstate;
